(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hiphone-completa-acquisto"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hiphone-upsell')) {
    customElements.define('hiphone-upsell', class extends HTMLElement {
      connectedCallback() {
        this.onCartUpdate = () => this.refreshCart();
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate);
        }
        this.onPageShow = () => this.refreshCart();
        window.addEventListener('pageshow', this.onPageShow);
        this.refreshCart();
      }
      disconnectedCallback() {
        this.unsubscribe?.();
        window.removeEventListener('pageshow', this.onPageShow);
        this.abortController?.abort();
      }
      async refreshCart() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart.js`, { signal: this.abortController.signal, credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) return;
          const cart = await response.json();
          if (!Array.isArray(cart.items) || !this.isConnected) return;
          const cards = Array.from(this.querySelectorAll('.hp-addon'));
          for (const card of cards) {
            card.hidden = cart.items.some(item => String(item.product_id) === card.dataset.productId && (card.dataset.isFilm !== 'true' || item.properties?.['Modello telefono'] === this.dataset.model));
          }
          this.hidden = cards.every(card => card.hidden);
        } catch (error) {
          if (error.name !== 'AbortError') this.dataset.cartSync = 'pending';
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hp-legami-header"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.hp-legami-search-toggle[open]').forEach((details) => {
    details.open = false;
    details.querySelector('summary').focus();
  });
});
document.addEventListener('click', (event) => {
  document.querySelectorAll('.hp-legami-search-toggle[open]').forEach((details) => {
    if (!details.contains(event.target)) details.open = false;
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    function expireHiPhoneOffers() {
    document.querySelectorAll('[data-offer-expires]').forEach((badge) => {
      if (Date.parse(badge.dataset.offerExpires) <= Date.now()) badge.style.display = 'none';
    });
    document.querySelectorAll('[data-hp-offer-card-expires]').forEach((card) => {
      if (Date.parse(card.dataset.hpOfferCardExpires) <= Date.now()) card.style.display = 'none';
    });
  }
  expireHiPhoneOffers();
  setInterval(expireHiPhoneOffers, 30000);
  } catch(e) { console.error(e); }
})();

})();
